import React, { useContext } from 'react';
import { Table, Tooltip } from 'antd';
import { LanguageContext } from 'contexts/LanguageContext';
import { FormattedMessage } from 'react-intl';
import enUS from 'antd/es/locale/en_US';
import ptBr from 'antd/es/locale/pt_BR';
import esEs from 'antd/es/locale/es_ES';
import { WidgetData } from 'interfaces/widgetData';
import '../../styles/widgetTable.css';

interface WidgetDataTableProps {
  dataSource: WidgetData[] | undefined;
}
function WidgetDataTable({ dataSource }: WidgetDataTableProps) {
  const { dictionary } = useContext(LanguageContext);

  const columns = [
    {
      title: (
        <Tooltip title={dictionary.widget_url_tooltip} placement="top">
          {dictionary.widget_url}
        </Tooltip>
      ),
      dataIndex: 'url',
      key: 'url',
      className: 'url-cell sorter-no-tooltip',
      sorter: (a: any, b: any) => (a.url > b.url ? 1 : -1),
    },
    {
      title: <FormattedMessage id="widget_number" />,
      dataIndex: 'number',
      key: 'number',
    },
    {
      title: (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <Tooltip title={dictionary.widget_redirects_tooltip}>{dictionary.widget_redirects}</Tooltip>
        </div>
      ),
      className: 'sorter-no-tooltip',
      dataIndex: 'redirects',
      key: 'redirects',
      width: 200,
      sorter: (a: any, b: any) => a.redirects - b.redirects,
    },
  ];

  const getLocale = () => {
    const locale = dictionary.locale;
    const localesMapping = {
      'pt-br': {
        sortTitle: 'Ordenar',
        emptyText:
          'Não há dados de Widget para o seu portal. Crie seu primeiro widget conectado a um número PowerZap e comece a coletar os dados',
        ...ptBr.Table,
      },
      en: {
        emptyText:
          'There is no widget data for your domain. Create your first widget connected to a PowerZap number and start collecting data',
        ...enUS.Table,
      },
      es: {
        emptyText:
          'No hay datos de widget para su dominio. Crea tu primer widget conectado a un número PowerZap y comienza a recopilar datos.',
        ...esEs.Table,
      },
    };

    if (locale in localesMapping) {
      return localesMapping[locale as keyof typeof localesMapping];
    }

    return enUS.Table;
  };

  return (
    <Table
      dataSource={dataSource}
      bordered
      columns={columns}
      size="small"
      pagination={{ pageSize: 8 }}
      locale={getLocale()}
    ></Table>
  );
}

export default WidgetDataTable;
